import * as React from "react";
import PropTypes from 'prop-types';

const SvgX = props => {
  if (props.id !== "_svgx") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path fill="#333" d="M134.143 120l85.595-85.595c3.905-3.905 3.905-10.237 0-14.143-3.906-3.904-10.236-3.904-14.143 0L120 105.857 34.404 20.262c-3.905-3.904-10.237-3.904-14.143 0-3.905 3.905-3.905 10.237 0 14.143L105.857 120l-85.595 85.595c-3.905 3.905-3.905 10.237 0 14.143 1.953 1.952 4.512 2.929 7.071 2.929s5.119-.977 7.071-2.929L120 134.143l85.595 85.595c1.953 1.952 4.512 2.929 7.071 2.929s5.118-.977 7.071-2.929c3.905-3.905 3.905-10.237 0-14.143L134.143 120z" /></svg>;
};

SvgX.displayName = "_svgx";
SvgX.propTypes = {
  id: PropTypes.string
};
SvgX.defaultProps = {
  id: ''
};
export default SvgX;